import { API, graphqlOperation } from "aws-amplify";

import { getMatchQuery } from "./graphql/queries";

const getMatch = (args) => API.graphql(graphqlOperation(getMatchQuery, args));

export default getMatch;
